<script setup lang="ts">
import type { BookmarkItem } from '@/types'

const props = defineProps<{
  bookmark: BookmarkItem
}>()

const emit = defineEmits<{
  'navigate': [bookmark: BookmarkItem]
}>()

function handleClick() {
  if (props.bookmark.url) {
    window.open(props.bookmark.url, '_blank')
  } else {
    emit('navigate', props.bookmark)
  }
}
</script>

<template>
  <div
    class="bookmark-card bg-card border border-border shadow-sm hover:shadow cursor-pointer transition-all duration-200 p-3 rounded flex items-center gap-3"
    @click="handleClick"
  >
    <div
      class="w-12 h-12 rounded-lg flex items-center justify-center text-primary-foreground flex-shrink-0"
      :class="bookmark.isFolder ? 'bg-primary' : 'bg-muted'"
    >
      <i :class="bookmark.isFolder ? 'fas fa-folder' : 'fas fa-bookmark'" class="text-xl"></i>
    </div>
    <div class="flex-1">
      <h3 class="font-medium text-card-foreground truncate">
        {{ bookmark.name }}
      </h3>
      <p
        v-if="!bookmark.isFolder && bookmark.url"
        class="text-sm text-muted-foreground truncate"
      >
        {{ bookmark.url }}
      </p>
      <p
        v-if="bookmark.isFolder && bookmark.children"
        class="text-sm text-muted-foreground"
      >
        {{ bookmark.children.length }} 项
      </p>
    </div>
  </div>
</template>
